export const entryTypes = {
  CATEGORY: "CATEGORY",
  TERM: "TERM",
  ADD_TERM_CONTROLLER: "ADD_TERM_CONTROLLER",
};

export const dictionaryTermTypes = {
  STRING: 0,
  WILDCARD_EXPRESSION: 1,
  REGULAR_EXPRESSION: 2,
};

// data test ids
export const hasBeenAlreadyDeletedError =
  "The dictionary has been deleted by another user";
export const menuOptionLockError =
  "You cannot complete this action, as dictionary is locked by another user";
export const dictionaryNotFound = "Dictionary Not Found";
export const saveButtonError =
  "You can't save the dictionary as there are validation errors. You'll see an \"i\" icon against the category or term below flagging specific issue(s). Fix those first.";

export const sortingModes = {
  ascending: "ascending",
  descending: "descending",
};

export const sortingKeys = {
  name: "name",
  createdBy: "createdBy",
  createdOn: "createdOn",
  lastUpdated: "lastUpdated",
  inUse: "inUse",
  usedBy: "usedBy",
  lastUsed: "lastUsed",
};

export const dictionaryDefaultColour = "#FCEFC7";

// Dictionary errors
export const CATEGORY_NOT_UNIQUE_ERROR =
  "The text entered is the same as another category name in the dictionary";
export const EMPTY_TERM = "Term name can't be empty";
export const EMPTY_CATEGORY = "Category name can't be empty";
export const TERM_SAME_COLOUR_ERROR =
  "This term is used in another category with the same color. To continue, you’ll need to reset the color used here to the default";
export const getTermNotUniqueError = (termName, categoryName) => {
  return `The term "${termName}" already exists in "${categoryName}". Please re-enter and try again`;
};

// Response errors
export const FILE_SIZE_INVALID = "FILE_SIZE_INVALID";
export const DICTIONARY_NAME_INVALID_CHARACTERS =
  "DICTIONARY_NAME_INVALID_CHARACTERS";
export const DICTIONARY_NAME_ALREADY_EXIST = "DICTIONARY_NAME_ALREADY_EXIST";
export const DICTIONARY_NAME_EMPTY = "DICTIONARY_NAME_EMPTY";
